// src/App.js
import React, { useState, useEffect } from 'react';
import { auth, db } from './firebase';
import { onAuthStateChanged, signOut, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import Dashboard from './components/Dashboard';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [isRegistering, setIsRegistering] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [nickname, setNickname] = useState('');
  const [inviteCode, setInviteCode] = useState(''); // <-- NEW: State for invite code
  const [error, setError] = useState('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setError('');
    });
    return () => unsubscribe();
  }, []);

  const handleAuthAction = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (isRegistering) {
        
        // --- NEW: Invite Code Validation ---
        if (inviteCode !== "brickerchores") {
          setError("Invalid invite code.");
          return; // Stop the registration
        }
        // --- End of New Block ---

        if (!nickname.trim()) {
          setError('Please enter a nickname.');
          return;
        }
        
        // 1. Create user in Auth
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const newUser = userCredential.user;
        
        // 2. Create user document in Firestore
        await setDoc(doc(db, "users", newUser.uid), {
          email: newUser.email,
          nickname: nickname
        });

      } else {
        // Just sign in
        await signInWithEmailAndPassword(auth, email, password);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      setError('Failed to log out.');
    }
  };
  
  if (user) {
    return <Dashboard user={user} handleLogout={handleLogout} />;
  }

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>{isRegistering ? 'Create Account' : 'Welcome Back'}</h2>
        <form onSubmit={handleAuthAction}>
          {isRegistering && (
            <input
              type="text"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              placeholder="Nickname"
              required
            />
          )}
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
          
          {/* --- NEW: Invite Code Input --- */}
          {isRegistering && (
            <input
              type="password" // Using 'password' hides the code as you type
              value={inviteCode}
              onChange={(e) => setInviteCode(e.target.value)}
              placeholder="Invite Code"
              required
            />
          )}
          {/* --- End of New Block --- */}

          <button type="submit">
            {isRegistering ? 'Register' : 'Login'}
          </button>
        </form>
        {error && <p className="error-message">{error}</p>}
        <button onClick={() => setIsRegistering(!isRegistering)} className="toggle-button">
          {isRegistering ? 'Already have an account? Login' : "Don't have an account? Register"}
        </button>
      </div>
    </div>
  );
}

export default App;